define("settings/controllers/overview/two-factor", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@ember/object/computed", "@glimmer/tracking", "later/utils/fetch"], function (_exports, _controller, _object, _service, _computed, _tracking, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TwoFactorController = (_dec = (0, _computed.reads)('auth.currentUserModel.otp_required_for_login'), _dec2 = (0, _computed.reads)('auth.currentUserModel.unconfirmed_two_factor'), _dec3 = (0, _computed.reads)('auth.currentUserModel'), (_class = class TwoFactorController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "router", _descriptor5, this);

      _initializerDefineProperty(this, "store", _descriptor6, this);

      _initializerDefineProperty(this, "otp_required", _descriptor7, this);

      _initializerDefineProperty(this, "unconfirmed_two_factor", _descriptor8, this);

      _initializerDefineProperty(this, "user", _descriptor9, this);

      _defineProperty(this, "qrCodeClassName", 'e--qr__code');

      _initializerDefineProperty(this, "backupCodes", _descriptor10, this);

      _initializerDefineProperty(this, "errorMessage", _descriptor11, this);

      _initializerDefineProperty(this, "otp", _descriptor12, this);

      _initializerDefineProperty(this, "qrCodeUrl", _descriptor13, this);
    }

    async setup() {
      try {
        const blob = await (0, _fetch.fetch)("/api/v2/users/setup_two_factor", {
          method: 'PATCH'
        });
        this.qrCodeUrl = URL.createObjectURL(blob);
      } catch (error) {
        this.errors.log(error);
      }
    }

    async confirm(secret) {
      this.errorMessage = null;

      try {
        const {
          user,
          backup_codes
        } = await (0, _fetch.fetch)("/api/v2/users/confirm_two_factor.json", {
          method: 'PATCH',
          body: {
            user: {
              otp_attempt: secret
            }
          }
        });
        this.backupCodes = backup_codes;
        this.store.pushPayload(user);
        this.auth.refresh();
        this.alerts.success(this.intl.t('alerts.account.two_factor.setup_complete'));
      } catch (error) {
        if (error.message.title) {
          if (!this.otp) {
            this.errorMessage = this.intl.t('alerts.account.two_factor.error_no_code');
          } else {
            this.errorMessage = this.intl.t('alerts.account.two_factor.error_incorrect_code');
          }
        }
      }
    }

    closeModal() {
      this.backupCodes = null;
      this.errorMessage = null;
      this.otp = null;
      this.qrCodeUrl = null;
      this.router.transitionTo('account.overview');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "otp_required", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "unconfirmed_two_factor", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "backupCodes", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "otp", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "qrCodeUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
  _exports.default = TwoFactorController;
});